<template>
  <div class="msg_layout">
    <div class="container msg_flex">
      <div class="msg_left">
        <div class="msg_left_top">
          <img src="~assets/msg/msg-select.png" alt="" style="height: 20px">
          <div>&nbsp;通知</div>
        </div>
        <div class="msg_left_content">
          <div v-for="(item,index) in msg_list" class="msg_left_item" :class="{'active':active_id==item.id}" @click="select(item)">
            <div style="color:#262626;font-size: 1.2rem">
              {{item.short_title}}
            </div>
            <div style="color: #606060;font-size: .9rem">
              {{item.short_content}}
            </div>
            <div style="color: #262626;">
              {{item.push_time}}
            </div>
          </div>
        </div>

      </div>
      <div class="msg_right">
        <div class="msg_box" v-if="msg.type===1">
        <div class="msg_title">
          {{ msg.title }}
        </div>
        <div class="msg_time">
          {{ msg.created_at }}
        </div>
        <div class="msg_content" v-if="msg.content">{{ msg.content }}</div>
      </div>
        <div class="msg_box" v-if="msg.type===2">
        <div class="msg_title">
          {{ msg.title }}
        </div>
        <div class="msg_time">
          {{ msg.created_at }}
        </div>
        <div class="msg_content" v-if="msg.content">{{ msg.content }}</div>
      </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.container {
  display: block;
  height: 100%;
  width: 960px;
  margin: 0 auto;
  padding: 2rem;
  box-sizing: border-box;
  margin-top: 1rem;
}

.msg_left_item{
  padding:.5rem;
  border-bottom: 1px solid #F6F6F6;
  &.active{
    border-left:3px solid #27BFA3;
  }
}

.msg_flex{
  height: 700px;
  display: flex;
}
.msg_left{
  width: 200px;
  background-color: #fff;
  overflow-y: auto;
}
.msg_right{
  width: 700px;
  margin-left: 1rem;
  background-color: #fff;
}

.msg_left_top{
  display: flex;
  padding: .5rem;
  border-bottom: 1px solid #F6F6F6;
}

.msg_box {
  padding: 1rem;
  min-height: 300px;
}

.wx_iframe {
  border: none;
  width: 750px;
}


.msg_title {
  font-size: 1.6rem;
  margin-bottom: .5rem;
  color:#262626;

}

.msg_time {
  font-size: 1rem;
  margin-bottom: 1rem;
  color:#606060;
}

.msg_content {
  padding:.5rem;
  background-color: #F4FCF9;
  white-space: pre-wrap;
  font-size: 1.15rem;
  color:#606060;
}

.msg_layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-size: 1620px 817px;
  background: url(~assets/yxp-bg.png) no-repeat center center;
}
</style>
<script>
import { getMsgDetail,getMsgList } from '../../services'
import mTypes from '@/store/mutationsTypes'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'msg_index',
  components: {},
  data () {
    return {
      msg: {},
      msg_id:this.$route.query.id,
      msg_list:[],
      active_id:this.$route.query.id,
    }
  },
  created () {
    this.init()
  },
  methods: {
    openwindow (url, name, iWidth, iHeight) {
      var iTop = (window.screen.height - 30 - iHeight) / 2       //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2        //获得窗口的水平位置;

      window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no')
    },
    select(item){
      if(item.type===3){
        this.openwindow(item.url,'',700,650);
        return false;
      }
      this.active_id=item.id;
      this.msg_list.map((map_item) => {
        if(map_item.id==item.id){
          this.msg=map_item;
        }
      })
    },
    reinitIframe () {
      let iframe = document.getElementById('test')
      try {
        let bHeight = iframe.contentWindow.document.body.scrollHeight
        let dHeight = iframe.contentWindow.document.documentElement.scrollHeight
        let height = Math.max(bHeight, dHeight)
        iframe.height = height
        console.log(height)
      } catch (ex) {
      }
    },
    async init () {

      getMsgList({
        pageSize:200,
        page:1,
      }).then(response => {
        if (response.code === 1) {
          this.msg_list=response.data.list.map((item) => {
            if (item.content.length >= 15) {
              item.short_content = (item.content.slice(0, 13) + '...')
            }else{
              item.short_content = item.content;
            }
            if (item.title.length >= 15) {
              item.short_title = (item.title.slice(0, 13) + '...')
            }else{
              item.short_title = item.title;
            }
            return item;
          });
        }
      })


      getMsgDetail({
        id: this.msg_id,
      }).then((res) => {
        if (res.data) {
          this.msg = res.data
          if(this.msg.type===3){
            if(this.msg.url){
              location.href=this.msg.url
            }else{
              this.msg.type=2;
            }
          }
        }
      })
    },
  },
}
</script>
